<template>
    <div id="app">
        <div class="box">
            <div class="left-content">
            <div class="console-logo">
                <div class="console-logo-icon"><img :src="require('@/assets/logo_buddycom_white.svg')"/></div>
                <div class="console-logo-text">Console</div>
            </div>
                <!----img class="aldiologo" :src="require('@/assets/logo_buddycom_console_white.svg')"/---->
            </div>
            <div class="right-content">
                <div class="dropdown-menu">
                    <el-dropdown split-button trigger="click" @command="handleAccountMenu">
                        {{ this.appData.loginId }}
                        <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="logout"><span v-t="'message.menu_logout'"/></el-dropdown-item>
                        <el-dropdown-item command="tenantInfo"><span v-t="'message.menu_tenant'"/></el-dropdown-item>
                        <el-dropdown-item command="twoPhaseLoginInfo"><span v-t="'message.item_two_phase_method_setting'"/></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
        <div id="root" class="root" :style="{ height: windowHeight+'px' }">
            <div :class="{ 'navi-menu' : appData.menuExpand, 'navi-menu-narrow' : !appData.menuExpand}">
                <div class="menu-change-button-field"><button class="menu-change-button" @click="handleChangeMenuWidth()">
                    <span v-if="appData.menuExpand"><img class="menu-change-icon" :src="require('@/assets/icon_left_white.svg')"/></span>
                    <span v-else><img class="menu-change-icon" :src="require('@/assets/icon_right_white.svg')"/></span>
                </button></div>
                <ul class="navi" v-for="menuitem in menuItems" v-on:click="appData.selectedMenu = menuitem.name" v-bind:class="{selected_menuitem: appData.selectedMenu == menuitem.name}">
                    <router-link v-if="showMenu" :to="menuitem.link">
                        <span v-if="appData.menuExpand">
                            <li><img :src="menuIconSrc(menuitem.name)"/>
                                <span>{{ getMenuDisplayName(menuitem.name) }}</span>
                                <el-badge v-if="menuitem.badge > 0" :value="appData.actionRequireTenantCount" class="badge-item">
                                </el-badge>
                            </li>
                        </span>
                        <span v-else>
                            <li>
                                <el-tooltip effect="light" placement="top-start" >
                                    <div slot="content" style="text-align:left"> {{ getMenuDisplayName(menuitem.name) }}</div>
                                    <img :src="menuIconSrc(menuitem.name)"/>
                                </el-tooltip>
                                <el-badge v-if="menuitem.badge > 0" :value="appData.actionRequireTenantCount" class="badge-item-narrow">
                                </el-badge>
                            </li>
                        </span>
                    </router-link>
                </ul>
            </div>
            <div :class="{ 'panel' : appData.menuExpand, 'panel-wide' : !appData.menuExpand}">
				<keep-alive>
                    <router-view
                        v-bind:appData="appData"
                        @loadTenantInfo="loadTenantInfo"
                        @loadLicenseInfo="getLicenseInfo"
                        @updateActionRequireTenantCount="updateActionRequireTenantCount"
                        @updateConnectedTenantList="updateConnectedTenantList"
                    ></router-view>
				</keep-alive>
            </div>
        </div>
    </div>
</template>
<script>
import server from "./components/ServerApi.js";
import constants from "./components/constants.js";
import commonUtil from "./components/commonutil.js";
import VueCookie from "vue-cookie";

export default {
    name: 'app',
    data() {
        return {
            showMenu: true,
            windowHeight: window.innerHeight - 50,
            appData: {
                loaded: false,
                commonFunc: null,
                basicContract: null,
                numberContract: null,
                usageContract: null,
                purchasedRecurringList: null,
                chargedList: null,
                countryCodeAlpha2: null,
                countryCodeAlpha3: null,
                menuExpand: true,
                onlinePurchase: false,
                webTrialTenant: false,
                terminatedContract: false,
                loginUserObjectId: 0,
                loginId: null,
                loginIdNotConfirmed: false,
                tenantAdminUser: false,
                radioManageUser: false,
                tenantOption: null,
                enableSpeechTextOption: false,
                enableTranslationOption: false,
                enableConfigOption: false,
                enableTrackingOption: false,
                enableMaptalkOption: false,
                enableAuditLogOption: false,
                enableVideoOption: false,
                enableSamlOption: false,
                enableSubgroupOption: false,
                enableE2EEncryptionOption: false,
                enableBell: false,
                enableCallCenter: false,
                enableBuddyBotApi: false,
                enableMapImageOverlay: false,
                enableBuddyComCall: false,
                enableSpeechTextTrial: false,
                enableTranslationTrial: false,
                enableConfigTrial: false,
                enableTrackingTrial: false,
                enableMaptalkTrial: false,
                enableAuditLogTrial: false,
                enableVideoTrial: false,
                enableSamlTrial: false,
                enableBellTrial: false,
                enableSafetySupport: false,
                enableCallCenterTrial: false,
                enableBuddyBotApiTrial: false,
                enableMapImageOverlayTrial: false,
                enableBuddyComCallTrial: false,
                enableSafetySupportTrial: false,
                enableLongTalkgroup: false,
                gmoSeverScriptPath: null,
                gmoShopId: null,
                tenantList: [],
                importedTenantList: [],
                exportedTenantList: [],
                actionRequireTenantCount: 0,
                csvProcessing: false,
                selectedMenu: null,
                twoPhaseMethod: false,
                twoPhaseMethodConsole: false,
                smsTwoPhaseMethod: false,
                e2eEncryption: false,
                aiAppCooperation: false,
                disableP2PSaveVoice: false,
                deviceManagement: false,
                clientSettingsForEachNode: false,
                taxRate: 0,
                customFieldName: null,
                isRadioIntegrated: false,
                isRadioTransitionUser: false,
                isRadioAdminOnlyUser: false,
                radioIntegratePermission: {
                    consoleManagementEditUserAndTalkGroupDefinition: false,
                    consoleManagementEditUserTalkGroupAssignment: false,
                    consoleManagementTracking: false,
                    radioManagementEditRadioSettingDefinition: false,
                    radioManagementEditRadioSettingAssignment: false,
                    radioManagementEditRadioSettingWifiItemsDefinition: false,
                    radioManagementEditRadioUserDisplayItemsDefinition: false,
                },
                rootNodePermission: 0,
            },
            menuItems: [] // タブリスト
        };
    },
    methods: {
        handleAccountMenu(commandName) {
            switch(commandName) {
                case "logout":
                    this.logout();
                    break;
                case "tenantInfo":
                    this.$router.push("/account");
                    break;
                case "twoPhaseLoginInfo":
                    this.$router.push("/twophaselogininfo");
                    break;
            }
        },
        handleWindowResize(event) {
            this.windowHeight = event.currentTarget.innerHeight - 50;
        },
        logout() {
            this.appData.loginId = null;
            sessionStorage.removeItem('loginId');
            window.location.href = "/static/login.html";
        },
        menuIconSrc: function(itemName) {
            switch(itemName) {
                case "user":
                    return require('@/assets/menu_user.svg');
                    break;
                case "talk":
                    return require('@/assets/menu_talk.svg');
                    break;
                case "map":
                    return require('@/assets/menu_map.svg');
                    break;
                case "bell":
                    return require('@/assets/menu_bell.svg');
                    break;
                case "announcement":
                    return require('@/assets/menu_qr.svg')
                case "setting":
                    return require('@/assets/menu_setting.svg');
                    break;
                case "restrictions":
                    return require('@/assets/menu_rights.svg');
                    break;
                case "license":
                    return require('@/assets/menu_license.svg');
                    break;
                case "billing":
                    return require('@/assets/menu_finance.svg');
                    break;
                case "manual":
                    return require('@/assets/menu_manual.svg');
                    break;
                case "auditlog":
                    return require('@/assets/menu_audit.svg');
                    break;
                case "keyvault":
                    return require('@/assets/menu_key.svg');
                    break;
                case "radio":
                    return require('@/assets/menu_radio.svg');
                    break;
            }
        },

        getMenuDisplayName(name) {
            switch(name) {
                case "user":
                    return commonUtil.getMessageText(this.$i18n,"menu_user_group");
                    break;
                case "talk":
                    return commonUtil.getMessageText(this.$i18n,"menu_talk_record");
                    break;
                case "restrictions":
                    return commonUtil.getMessageText(this.$i18n,"menu_restrictions");
                    break;
                case "setting":
                    return commonUtil.getMessageText(this.$i18n,"menu_setting");
                    break;
                case "license":
                    return commonUtil.getMessageText(this.$i18n,"menu_license");
                    break;
                case "map":
                    return commonUtil.getMessageText(this.$i18n,"menu_tracking");
                    break;
                case "bell":
                    return commonUtil.getMessageText(this.$i18n,"menu_bell");
                    break;
                case "announcement":
                    return commonUtil.getMessageText(this.$i18n, "menu_qr");
                case "billing":
                    return commonUtil.getMessageText(this.$i18n,"menu_billing");
                    break;
                case "manual":
                    return commonUtil.getMessageText(this.$i18n,"menu_manual");
                    break;
                case "auditlog":
                    return commonUtil.getMessageText(this.$i18n,"menu_audit");
                    break;
                case "keyvault":
                    return commonUtil.getMessageText(this.$i18n,"menu_key_vault");
                    break;
                case "radio":
                    return commonUtil.getMessageText(this.$i18n,"menu_radio");
            }
        },
        hideLicenseMenuForAppless() {
            if (this.appData.basicContract != null &&
                this.appData.basicContract.state === constants.CONTRACT_APPLESS) {
                this.menuItems = this.menuItems.filter((element) => element.name !== "license");
            }
        },

        getBasicContract(tenantId) {
            let self = this;
            server.post('/getbasiccontract', { tenantId: tenantId} )
                .then((res) => {
                    if (res.data.status == constants.STATUS_SUCCESS) {
                        this.appData.basicContract = res.data;
                        if ((res.data.billingType == constants.BILLING_CREDIT_CARD) || (res.data.billingType == constants.BILLING_PAID) || (res.data.billingType == constants.BILLING_TRANSFER)) {
                            this.appData.onlinePurchase = true;
                            this.appData.webTrialTenant = false;
                            if (sessionStorage.getItem('initMenu') == "map") {
                                sessionStorage.removeItem("initMenu");
                            }
                        } else if (res.data.billingType == constants.BILLING_UNDEFINED) {
                            this.appData.onlinePurchase = true;
                            this.appData.webTrialTenant = true;
                            if (sessionStorage.getItem('initMenu') == "map") {
                                sessionStorage.removeItem("initMenu");
                            }
                        } else if (res.data.billingType == constants.BILLING_PAPER) {
                            let mapMenu = this.menuItems.filter(function (element) {
                                return element.name == "map";
                            });
                            if (mapMenu.length == 0) {
                                this.menuItems.splice(2, 0, { name: "map" , link: "/map" , label: commonUtil.getMessageText(this.$i18n,"menu_tracking") });
                            }
                        }
                        if ((res.data.optionTrial & constants.TRIAL_OPTION_ACCESS_LOG) != 0) {
                            let mapMenu = this.menuItems.filter(function (element) {
                                return element.name == "auditlog";
                            });
                            if (mapMenu.length == 0) {
                                this.menuItems.push({ name: "auditlog" , link: "/auditlog" , label: commonUtil.getMessageText(this.$i18n,"menu_audit") });
                            }
                        }

                        if ((res.data.state == constants.CONTRACT_TERMINATE) ||
                            (res.data.state == constants.CONTRACT_TRIAL_END)) {
                            this.appData.terminatedContract = true;
                        }

                        self.appData.enableSpeechTextTrial = (res.data.optionTrial & constants.TRIAL_OPTION_SPEECH_TEXT) !== 0;
                        self.appData.enableTranslationTrial = (res.data.optionTrial & constants.TRIAL_OPTION_TRANSLATION) !== 0;
                        self.appData.enableConfigTrial = (res.data.optionTrial & constants.TRIAL_OPTION_CONFIG) !== 0;
                        self.appData.enableTrackingTrial = (res.data.optionTrial & constants.TRIAL_OPTION_TRACKING) !== 0;
                        self.appData.enableMaptalkTrial = (res.data.optionTrial & constants.TRIAL_OPTION_MAP_TALK) !== 0;
                        self.appData.enableVideoTrial = (res.data.optionTrial & constants.TRIAL_OPTION_VIDEO) !== 0;
                        self.appData.enableAuditLogTrial = (res.data.optionTrial & constants.TRIAL_OPTION_ACCESS_LOG) !== 0;
                        self.appData.enableSamlTrial = (res.data.optionTrial & constants.TRIAL_OPTION_SAML) !== 0;
                        self.appData.enableBellTrial = (res.data.optionTrial & constants.TRIAL_OPTION_BELL) !== 0;
                        self.appData.enableCallCenterTrial = (res.data.optionTrial & constants.TRIAL_OPTION_CALL_CENTER) !== 0;
                        self.appData.enableBuddyBotApi = (res.data.optionTrial & constants.TRIAL_OPTION_BUDDY_BOT_API) !== 0;
                        self.appData.enableMapImageOverlayTrial = (res.data.optionTrial & constants.TRIAL_OPTION_MAP_IMAGE_OVERLAY) !== 0;
                        self.appData.enableBuddyComCallTrial = (res.data.optionTrial & constants.TRIAL_OPTION_BUDDYCOM_CALL) !== 0;
                        self.appData.enableSafetySupportTrial = (res.data.optionTrial & constants.TRIAL_OPTION_SAFETY_SUPPORT) !== 0;
                        this.hideLicenseMenuForAppless();
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self , "getBasicContract" , error)
                });
        },
        getLicenseInfo(tenantId) {
            let self = this;
            server.post('/getlicenseinfo', {tenantId: tenantId})
                .then((res) => {
                    if (res.data.status == constants.STATUS_SUCCESS) {
                        this.appData.numberContract = res.data.numberContractList;
                        this.appData.usageContract = res.data.usageContractList;
                        this.appData.purchasedRecurringList = res.data.purchasedRecurringList;
                        this.appData.chargedList = res.data.chargedList;
                        for (let license of res.data.numberContractList) {
                            switch(Number(license.type)) {
                                case constants.LICENSE_SPEECH_TEXT :
                                    self.appData.enableSpeechTextOption = license.currentMax > 0;
                                    break;
                                case constants.LICENSE_TRANSLATION :
                                    self.appData.enableTranslationOption = license.currentMax > 0;
                                    break;
                                case constants.LICENSE_CONFIG :
                                    self.appData.enableConfigOption = license.currentMax > 0;
                                    break;
                                case constants.LICENSE_ACCESS_LOG :
                                    self.appData.enableAuditLogOption = license.currentMax > 0;
                                    let mapMenu = this.menuItems.filter(function (element) {
                                        return element.name == "auditlog";
                                    });
                                    if (mapMenu.length == 0) {
                                        this.menuItems.push({ name: "auditlog" , link: "/auditlog" , label: commonUtil.getMessageText(this.$i18n,"menu_audit") });
                                    }
                                    break;
                                case constants.LICENSE_TRACKING :
                                    self.appData.enableTrackingOption = license.currentMax > 0;
                                    break;
                                case constants.LICENSE_MAP_TALK :
                                    self.appData.enableMaptalkOption = license.currentMax > 0;
                                    break;
                                case constants.LICENSE_VIDEO :
                                    self.appData.enableVideoOption = license.currentMax > 0;
                                    break;
                                case constants.LICENSE_SAML :
                                    self.appData.enableSamlOption = license.currentMax > 0;
                                    break;
                                case constants.OFF_PLAN_LICENSE_BELL:
                                    self.appData.enableBell = license.currentMax > 0;
                                    break;
                                case constants.OFF_PLAN_LICENSE_CALL_CENTER:
                                    self.appData.enableCallCenter = license.currentMax > 0;
                                    break;
                                case constants.OFF_PLAN_LICENSE_BUDDY_BOT_API:
                                    self.appData.enableBuddyBotApi = license.currentMax > 0;
                                    break;
                                case constants.OFF_PLAN_LICENSE_MAP_IMAGE_OVERLAY:
                                    self.appData.enableMapImageOverlay = license.currentMax > 0;
                                    break;
                                case constants.OFF_PLAN_LICENSE_CALL:
                                    self.appData.enableBuddyComCall = license.currentMax > 0;
                                break;
                                case constants.OFF_PLAN_LICENSE_SAFETY_SUPPORT:
                                    self.appData.enableSafetySupport = license.currentMax > 0;
                                    break;
                            }
                        }
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self , "getLicenseInfo" , error)
                });
        },
        updateActionRequireTenantCount(count) {
            this.appData.actionRequireTenantCount = count;
        },
        getLoginUserObjectId(userId) {
            let self = this;
            self.appData.loginIdNotConfirmed = false
            server.post('/getinfo', {tenantId: this.appData.tenantList[0].tenantId, name: userId, type: constants.OBJECT_USER })
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.appData.loginUserObjectId = res.data.id;
                            self.appData.tenantAdminUser = commonUtil.checkUserPrivilege(res.data.rights, constants.PRIVILEGE_TENANT_ADMIN);
                            self.appData.radioManageUser = commonUtil.checkUserPrivilege(res.data.rights, constants.PRIVILEGE_RADIO_MANAGE);
                            self.appData.isRadioTransitionUser = (res.data.flag & constants.TRANSITION) !== 0;
                            self.appData.isRadioAdminOnlyUser = (res.data.flag & constants.ADMIN_ONLY) !== 0;
                            if (self.appData.isRadioIntegrated) {
                                self.getRadioIntegratePermission();
                            }
                            return;
                        case constants.STATUS_ERROR_DENIED:
                            self.appData.loginIdNotConfirmed = true;
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_login_by_denied"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getLoginUserObjectId").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self , "getLoginUserObjectId" , error)
                });
        },
        getGMOServerInfo() {
            let self = this;
            server.post('/gmopaymentserverinfo')
                .then((res) => {
                    this.appData.gmoSeverScriptPath = res.data.serverScriptPath
                    this.appData.gmoShopId = res.data.shopId
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self , "getGMOServerInfo" , error)
                });
        },
        updateConnectedTenantList() {
            this.getConnectedTenantList();
        },
        getConnectedTenantList() {
            let self = this;
            server.post('/gettenantconnectinfo',{type: 0})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            this.appData.actionRequireTenantCount = 0;
                            self.appData.importedTenantList = res.data.importTenantList;
                            self.appData.exportedTenantList = res.data.exportTenantList;
                            let actionRequireTenantCount = 0;
                            for (let importTenant of self.appData.importedTenantList ) {
                                if (importTenant.state == constants.TENANT_CONNECT_ALLOW) {
                                    actionRequireTenantCount ++;
                                }
                            }
                            for (let exportTenant of self.appData.exportedTenantList) {
                                if (exportTenant.state == constants.TENANT_CONNECT_WANT) {
                                    actionRequireTenantCount ++;
                                }
                            }
                            self.appData.actionRequireTenantCount = actionRequireTenantCount;
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error","システムエラーが発生しました function = getTenantConnectInfo code = " + res.data.status);
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getTenantConnectInfo", error);
                });
        },
        handleChangeMenuWidth() {
            if (this.appData.menuExpand) {
                this.appData.menuExpand = false;
            } else {
                this.appData.menuExpand = true;
            }
        },
        handleChangeLang(lang) {
            this.$i18n.locale = lang;
            VueCookie.set("buddycom-lang",lang);
        },
        async loadTenantInfo() {
            let actionPromises = []
            for (let actionKey in this.$root.store.actions) {
                if (this.$root.store.actions.hasOwnProperty(actionKey)) {
                    let action = this.$root.store.actions[actionKey]
                    actionPromises.push(await action())
                }
            }

            let self = this
            Promise.all(actionPromises).then(() =>{
                let array = []
                for (let tenant of self.$root.store.tenantList) {
                    array.push({
                        tenantId: tenant.tenantId,
                        id: 1,
                        label: "ROOT-NODE",
                        name: tenant.name,
                        displayName: tenant.displayName,
                        departmentName: tenant.departmentName,
                        primaryOwner: tenant.primaryOwner,
                        primaryOwnerName: tenant.primaryOwnerName,
                        phoneNumber: tenant.phoneNumber,
                        zip: tenant.zip,
                        addressPref: tenant.addressPref,
                        addressCity: tenant.addressCity,
                        addressTown: tenant.addressTown,
                        addressStreet: tenant.addressStreet,
                        type: 0,
                        idpMetaData: tenant.idpMetaData,
                        samlLayer: tenant.samlLayer,
                        samlGroup: tenant.samlGroup,
                        samlAttributeFormula: tenant.samlAttributeFormula,
                        autoExtendLicenseLimit: tenant.autoExtendLicenseLimit,
                        isLeaf: false
                    })
                }
                self.appData.tenantList = array;
                self.appData.tenantOption = self.$root.store.tenantList[0].optionFlag;
                self.appData.enableSubgroupOption = (self.appData.tenantOption & constants.ENABLE_SUBGROUP) !== 0;
                self.appData.enableE2EEncryptionOption = (self.appData.tenantOption & constants.ENABLE_E2E_ENCRYPTION) !== 0;
                self.appData.isRadioIntegrated = self.$root.store.tenantList[0].isRadioIntegrated;

                if (self.appData.isRadioIntegrated === false) {
                    self.menuItems = self.menuItems.filter(e => e.name !== "radio");
                }

                let countryCode = commonUtil.getCountryList().filter(function(item, index){
                    if (item.value === self.$root.store.tenantList[0].countryCode) return true;
                });
                self.appData.countryCodeAlpha2 = countryCode[0].alpha2;
                self.appData.countryCodeAlpha3 = self.$root.store.tenantList[0].countryCode;
                if (self.appData.countryCodeAlpha3 === "JPN") {
                    self.getConsumptionTaxRate();
                }

                self.getBasicContract( self.$root.store.tenantList[0].tenantId);
                self.getLoginUserObjectId(this.appData.loginId.split("@")[0]);
                self.getLicenseInfo( self.$root.store.tenantList[0].tenantId);
                self.getOptionOfThisTenant();
                self.getAppsOfThisTenant();

                if (self.appData.isRadioIntegrated && self.loginUserObjectId) {
                    self.getRadioIntegratePermission();
                }
            }).catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self , "loadTenantInfo" , error)
            });
        },
        checkAppDataLoading() {
            if ((this.appData.basicContract != null) &&
                (this.appData.numberContract != null) &&
                (this.appData.tenantList.length > 0)) {
                this.$root.store.appData = this.appData
                this.appData.loaded = true;
            }
        },
        getOptionOfThisTenant() {
            let self = this;
            server.post('/gettenantoption')
                .then((res) => {
                    if (res.data.status == constants.STATUS_SUCCESS) {
                        self.appData.twoPhaseMethod = res.data.twoPhaseMethod;
                        self.appData.twoPhaseMethodConsole = res.data.twoPhaseMethodConsole;
                        self.appData.smsTwoPhaseMethod = res.data.smsTwoPhaseMethod;
                        self.appData.e2eEncryption = res.data.e2eEncryption;
                        self.appData.aiAppCooperation = res.data.aiAppCooperation;
                        self.appData.disableP2PSaveVoice = res.data.disableP2PSaveVoice;
                        self.appData.deviceManagement = res.data.deviceManagement;
                        self.appData.clientSettingsForEachNode = res.data.clientSettingsForEachNode;
                        self.appData.enableLongTalkgroup = res.data.longTalkgroup;
                        self.appData.customFieldName = res.data.customFieldName;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "mounted", error);
                });
        },
        getAppsOfThisTenant() {
            let self = this;
            server.post('/gettenantapps')
                .then((res) => {
                    if (res.data.status == constants.STATUS_SUCCESS) {
                        self.appData.apps = res.data.apps;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "mounted", error);
                });
        },
        getConsumptionTaxRate() {
            let self = this;
            server.post('/getconsumptiontaxrate')
                .then((res) => {
                    if (res.data.status == constants.STATUS_SUCCESS) {
                        self.appData.taxRate = res.data.taxRate;
                    } else {
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getConsumptionTaxRate").replace("{code}",res.data.status));
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getConsumptionTaxRate", error);
                });
        },
        async getRadioIntegratePermission() {
            try {
                let res = await server.post('/getuserinfoandradiointegratepermissions', {userId: this.appData.loginUserObjectId})

                if (res.data.status === constants.STATUS_SUCCESS) {
                    this.appData.radioIntegratePermission.consoleManagementEditUserAndTalkGroupDefinition = res.data.permissions.consoleManagementEditUserAndTalkGroupDefinition;
                    this.appData.radioIntegratePermission.consoleManagementEditUserTalkGroupAssignment = res.data.permissions.consoleManagementEditUserTalkGroupAssignment;
                    this.appData.radioIntegratePermission.consoleManagementTracking = res.data.permissions.consoleManagementTracking;
                    this.appData.radioIntegratePermission.radioManagementEditRadioSettingDefinition = res.data.permissions.radioManagementEditRadioSettingDefinition;
                    this.appData.radioIntegratePermission.radioManagementEditRadioSettingAssignment = res.data.permissions.radioManagementEditRadioSettingAssignment;
                    this.appData.radioIntegratePermission.radioManagementEditRadioSettingWifiItemsDefinition = res.data.permissions.radioManagementEditRadioSettingWifiItemsDefinition;
                    this.appData.radioIntegratePermission.radioManagementEditRadioUserDisplayItemsDefinition = res.data.permissions.radioManagementEditRadioUserDisplayItemsDefinition;
                    this.appData.rootNodePermission = res.data.rootNodePermission;
                } else {
                    commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getRadioIntegratePermission").replace("{code}",res.data.status));
                }

                if (commonUtil.isTrackingOnlyGeneralAdmin(this.appData)) {
                    this.menuItems = this.menuItems.filter(e => e.name === "map");
                    this.$set(this.appData, 'selectedMenu', 'map')
                    if (this.$router.currentRoute.path !== this.menuItems[0].link) {
                        await this.$router.push(this.menuItems[0].link);
                    }
                } else {
                    if (!commonUtil.canViewConsoleTracking(this.appData)) {
                        this.menuItems = this.menuItems.filter(e => e.name !== "map");
                        this.$set(this.appData, 'selectedMenu', this.menuItems[0].name)
                        if (this.$router.currentRoute.path !== this.menuItems[0].link) {
                            await this.$router.push(this.menuItems[0].link);
                        }
                    }

                    if (!commonUtil.isGeneralAdminAccount(this.appData)) {
                        // 無線機管理一般ユーザーは無線機操作権限によって制御されるため無線機メニューは必ず表示される
                        if (!this.appData.radioManageUser) {
                            this.menuItems = this.menuItems.filter(e => e.name !== "radio");
                        }
                    }
                }
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "getRadioIntegratePermission", error);
            }
        },
    },
    created: function() {
        this.appData.commonFunc = this;
        if (this.appData.loginId == null) {
            if (sessionStorage.getItem('loginId') == null) {
                location.href = "/static/login.html";
            } else {
                this.appData.loginId = sessionStorage.getItem('loginId');
            }
        }

        let initMenuItem = sessionStorage.getItem('initMenu');
        if (initMenuItem != null) {
            if (initMenuItem == "map") {
                this.$router.push({path: "/" + initMenuItem})
                this.appData.selectedMenu = initMenuItem;
                this.appData.menuExpand = false;
            }
        } else {
            if (location.hash == "#/") {
                this.appData.selectedMenu = "user";
            } else {
                this.appData.selectedMenu = location.hash.slice(2,location.hash.length);
            }
        }

        this.getGMOServerInfo();
        this.getConnectedTenantList();
        this.menuItems = commonUtil.getMenuItems();

        this.loadTenantInfo();
    },
    mounted() {
        this.$i18n.locale = commonUtil.getBrowserLanguage(VueCookie.get("buddycom-lang"));
        // remove menu item on English console.
        // ToDo: remove this when English manual is available.
        if (this.$i18n.locale != 'ja') {
            for (let i = 0 ; i < this.menuItems.length - 1 ; i++) {
                if (this.menuItems[i].name == "manual") {
                    this.menuItems.splice(i , 1);
                    break;
                }
            }
            // reDraw the menu items after remove the manual-menu
            this.showMenu = false;
            this.$nextTick(() => {
                 this.showMenu = true
            })
        }
        window.addEventListener('resize', this.handleWindowResize);
    },
    watch: {
        'appData.onlinePurchase'(newVal) {
            let billingMenu = this.menuItems.filter(function (element) {
                return element.name === "billing";
            });
            if (billingMenu.length === 0) {
                this.menuItems.push({name: "billing" , link: "/billing" , label: commonUtil.getMessageText(this.$i18n,"menu_billing") });
            }

            this.menuItems = this.menuItems.filter(function (element) {
                return element.name !== "bell";
            });
        },
        'appData.actionRequireTenantCount'(newVal) {
            for (let menuItem of this.menuItems) {
                if (menuItem.name == "setting") {
                    menuItem.badge = this.appData.actionRequireTenantCount;
                }
            }
        },
        'appData.tenantList'(newVal) {
            this.checkAppDataLoading();
        },
        'appData.basicContract'(newVal) {
            this.hideLicenseMenuForAppless();
            this.checkAppDataLoading();
        },
        'appData.numberContract'(newVal) {
            this.checkAppDataLoading();
        }
    },
}
</script>

<style>
html {
	margin: 0;
}

table {
    border-collapse: collapse;
}

body {
    font-size: 14px;
    color: #333B48;
	margin: 0;
	overflow-y: hidden;
    font-family: sans-serif;
}

h1 {
    padding-left: 20px;
    padding-top: 20px;
    padding-bottom: 0;
	font-size: 20px;
	font-weight: bold;
	margin: 0;
}

li {
    font-size: 12px;
    padding: 0px;
    line-height: 64px;
    list-style:none;
    vertical-align: middle;
    padding-left: 18px;
}
li:hover {
    background-color: #5171cb;
}
li img {
  display: inline;
  vertical-align: middle;
  padding-right: 8px;
}

td {
    padding: 0;
}

.el-radio__input.is-checked+.el-radio__label {
    color: #5171cb;
}
.el-radio__input.is-checked .el-radio__inner {
    border-color: #5171cb;
    background: #5171cb;
}

.el-badge.badge-item {
    position: absolute;
    padding-top: 5px;
    padding-left: 5px;
}
.el-badge.badge-item-narrow {
    position: absolute;
    left: 35px;
    padding-top: 12px;
}
.badge-item > .el-badge__content,
.badge-item-narrow > .el-badge__content {
    background-color: #d55169;
    border: none;
    width: 8px;
    padding: 4px;
    height: 8px;
    line-height: 7px;
    font-size: 10px;
}

.left-content {
    color: #ffffff;
    width: 30%;
    display: table-cell;
    text-align: left;
    padding-left: 28px;
    padding-top: 10px;
    padding-bottom: 10px;
    vertical-align: bottom;
}

.right-content {
    width: 70%;
    display: table-cell;
    text-align : right;
    vertical-align: middle;
}

button.el-button--primary {
    color: #ffffff;
    background-color: #5171cb!important;
    border-color: #5171cb!important;
}
button.el-button--primary:focus, button.el-button--primary:hover {
    color: #ffffff!important;
    background-color: #5171cb!important;
    border-color: #5171cb!important;
    opacity: 0.8;
}
button.el-button, button.el-button {
    background-color: #fafafa;
}
button.el-button:focus, button.el-button:hover {
    color: #000000;
    background-color: #fafafa;
    opacity: 0.8;
}

button.transparent {
    border-style: none;
    background-color: transparent;
    cursor: pointer;
    outline: none;
}

button.menu-change-button {
    height: 45px;
    vertical-align: middle;
    border-style: none;
    background-color: transparent;
    color: #fff;
    outline: 0;
    cursor: pointer;
}
.button-icon {
    height: 18px;
    vertical-align: middle;
    margin-right: 4px;
}
.subtitle {
    color: #848991;
}
.subtitlebox {
  width: 100%;
  display: table;
}
.subtitlebox-left {
    font-weight: normal;
    font-size: 14px;
    padding-left: 20px;
    padding-top: 16px;
    padding-bottom: 20px;
    color: #848991;
    width: 50%;
    display: table-cell;
    vertical-align: middle;
}
.subtitlebox-right {
    padding-right: 24px;
    position: relative;
    width: 50%;
    display: table-cell;
    text-align : right;
    vertical-align: middle;
}

button.item-record-button {
    border-style: none;
    background-color: transparent;
    cursor: pointer;
    outline: 0;
    width: 100%
}
button.item-record-button img {
    display: inline;
    vertical-align: middle;
    height: 18px;
}
button.transparent-button {
    border-style: none;
    color: #333B48;
    background-color: transparent;
    cursor: pointer;
    outline: 0;
}
button.transparent-button-disabled {
    border-style: none;
    font-size: 12px;
    color: #848991;
    background-color: transparent;
    cursor: not-allowed	;
    outline: 0;
}

.transparent-button img ,
.transparent-button-disabled img {
  display: inline;
  vertical-align: middle;
  height: 18px;
  padding-right: 4px;
}

button.back-button {
    border-style: none;
    color: #333B48;
    background-color: transparent;
    cursor: pointer;
    outline: 0;
}

.back-button img {
  display: inline;
  vertical-align: middle;
  height: 22px;
  padding-right: 4px;
  transform: rotate(180deg);
}

/* remove spin button from input box */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type="number"] {
    -moz-appearance:textfield;
}

/*
 * panel , dialog
 */
.dialog-modal-mask {
    position: fixed;
    z-index: 1999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.main-panel {
	height: 100%;
	background-color: #ffffff;
	overflow-y: auto;
}

.user-panel {
	height: 100%;
	background-color: #ffffff;
}

.large-panel-fix {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 1000px;
    height: 80vh;
    margin-left: -500px;
    margin-top: -40vh;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
}

.large-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 1000px;
    height: 80vh;
    margin-left: -500px;
    margin-top: -40vh;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
}

.small-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 500px;
    max-height: 80vh;
    margin-top: -40vh;
    margin-left: -250px;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -webkit-overflow-scrolling: touch;
    overflow: hidden;
}

.import-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 1200px;
    height: auto;
    margin-left: -600px;
    margin-top: -40vh;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
}

.inner-panel {
	position:relative;
    height: calc(100% - 40px);
    margin: 0;
    overflow: auto;
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
}

.inner-panel-dialog {
	position:relative;
    height: calc(80vh - 180px);
    margin: 0;
    overflow: auto;
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
}

.inner-panel-userselect {
	position:relative;
    height: calc(80vh - 240px);
    margin: 0;
    overflow: auto;
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
}

.inner-panel-header {
    height: 32px;
    width:100%;
    vertical-align: middle;
    display: inline-table;
    background-color: #f6f6f6;
}
.inner-panel-title {
    padding: 6px;
    font-size: 12px;
    height: 28px;
    color: #848991;
    background-color: #f6f6f6;
    padding-left: 20px;
    vertical-align: middle;
    display: table-cell;
}

.inner-panel-title-left {
  float: left;
  color: #848991;
  font-size: 12px;
  vertical-align: middle;
}

.inner-panel-title-right {
  padding-right: 20px;
  position: relative;
  text-align : right;
  vertical-align: middle;
  font-size: 12px;
}

.inner-panel-user-select {
	position:relative;
    height: calc(80vh - 240px);
    margin: 0;
    overflow: auto;
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
}

.panel-title-title {
    color: #848991;
}
.panel-title-box {
  width: 100%;
  display: table;
}

.panel-title-box img {
  display: inline;
  vertical-align: middle;
  height: 25px;
  padding-left: 16px;
  padding-right: 4px;
}
.panel-title-box-left {
    font-weight: normal;
    font-size: 14px;
    padding-left: 20px;
    padding-top: 16px;
    padding-bottom: 20px;
    color: #848991;
    width: 50%;
    display: table-cell;
    vertical-align: middle;
}
.panel-title-box-right {
    padding-right: 24px;
    position: relative;
    width: 50%;
    display: table-cell;
    text-align : right;
    vertical-align: middle;
}

.panel-command-box {
    background-color: #ecf1fa;
    width: 100%;
    display: block;
    text-align: left;
    padding-left: 20px;
    height: 56px;
    vertical-align: bottom;
}
.panel-command-box-left {
    padding-top: 10px;
    padding-bottom: 10px;
    vertical-align: middle;
    float: left;
}
.panel-command-box-right {
    padding-right: 24px;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align : right;
    vertical-align: middle;
}

.objectTree {
	overflow: hidden;
	position: absolute;
	top: 0;
	right:0;
	bottom: 0;
	left: 0;
}

.input-with-select {
    width: 400px;
    padding-bottom: 10px;
}

.input-with-select >>> .el-input-group__prepend {
    background-color: #fff;
}

.input-with-select >>> .el-select .el-input {
    font-size: 14px;
    width: 120px;
}

.input-with-select >>> .el-button {
    width: 40px;
    padding: 0;
}

.input-with-select >>> .el-input__inner {
    font-size: 14px;
    padding-left: 10px;
}

.command-button {
    display: inline-block;
}
.command-button > .el-button {
    font-size: 14px;
    padding: 10px 30px;
    padding-left: 10px;
    padding-right: 16px;
    color: #ffffff;
    position: relative;
    display: inline-block;
    background-color: #5171cb;
    cursor: pointer;
}
.command-button > .el-button:hover,
.command-button > .el-button:active,
.command-button > .el-button:focus {
    color: #ffffff;
    background-color: #5171cb;
    border-color: #5171cb;
    opacity: 0.8;
}

.command-button > .el-button.is-disabled,
.command-button > .el-button.is-disabled:active,
.command-button > .el-button.is-disabled:focus,
.command-button > .el-button.is-disabled:hover {
    color: #ffffff;
    background-color: #5171cb;
    opacity: 0.3;
}

.selected-item-field {
    margin: 0;
    padding-left: 20px;
    padding-top: 10px;
    height: 100%;
}

.confirm-body {
    padding: 20px;
    font-size: 14px;
}

.select-option-item >>> el-select {
    width:260px;
}
.select-option-item >>> .el-input__inner {
    width:260px;
}
.el-select-dropdown__item.selected {
    color: #5171cb;
}
.select-option-item >>> .el-select-dropdown__item.selected {
    color: #5171cb;
}
.el-input.input-select-talkgroup {
    width:225px;
}
.el-input.input-enable-saml {
    width:195px;
}
.el-input-number.input-enable-saml {
    width:195px;
}

.search-type-select >>> .el-radio-button__inner {
    width: 140px;
}

.object-search-select {
    width: 400px;
}
.object-search-select >>> .el-input-group__prepend {
    background-color: #f5f7fa;
}
.object-search-select >>> .el-button {
    width: 40px;
    padding: 0;
}
.object-search-select >>> .el-input__inner {
    font-size: 14px;
    padding-left: 10px;
}
.object-search-select.el-input-group {
    width: 650px;
    padding-left: 20px;
    padding-bottom: 0;
}
.el-select.search-item {
    font-size: 14px;
    width: 160px;
}
.el-button.search-button {
    width: 100px;
    vertical-align: middle;
}

.foundObject-record {
  cursor: pointer;
  word-break: break-all;
}
.foundObject-record:hover {
  background-color: #ecf1fa;
}

.foundObject {
  padding: 10px 20px;
  display: flex;
}

.dialog-title {
    padding: 8px 20px 4px 20px;
    height: 60px;
    vertical-align: middle;
    display: table-cell;
    font-size: 16px;
    font-weight: 700;
}

.dialog-body {
    height: -webkit-calc(100% - 140px);
    padding: 0;
    font-size: 14px;
}

.dialog-body-small {
    max-height: calc(80vh - 150px);
    padding: 10px 20px;
    font-size: 14px;
    overflow-y: scroll;
    overflow-x: hidden;
}

.dialog-body-import {
    max-height: calc(80vh - 150px);
    font-size: 14px;
    overflow: auto;
}

hr.dialog-hr {
    border: none;
    height: 1px;
    background-color: #eee;
    margin: 0.3px;
}
hr.transparent-hr {
    border: none;
    height: 1px;
    background-color: transparent;
    margin: 20px;
}

.dialog-td {
    width: 50%;
    vertical-align: top;
    margin: 0;
    padding: 0;
}

.default-message {
    position: relative;
    top: 10%;
    color: #848991;
    text-align: center;
    vertical-align: middle;
}

.no-data-message {
    display: block;
    width: 100%;
    padding-top: 10vh;
    opacity: 0.6;
    text-align: center;
}

.dialog-button-field {
    padding-top: 12px;
    padding-bottom: 12px;
    padding-right: 20px;
    text-align: right;
    vertical-align: middle;
}

.dialog-form-item {
}

.dialog-form-item > .el-form-item__error {
    color: #d55169;
    padding-top: 8px;
}
.dialog-form-item > .el-form-item.is-error .el-input__inner {
    border-color:#d55169;
}
.dialog-form-item > .el-form-item.is-error {
    margin-bottom: 30px;;
}
.dialog-form-item > .el-form-item.is-success .el-input__inner,
.dialog-form-item > .el-form-item.is-success .el-input__inner:focus,
.dialog-form-item > .el-form-item.is-error .el-input__inner:focus {
    border-color:#5171cb;
}
.dialog-form-item > .el-form-item.is-success {
    margin-bottom: 22px;;
}
.dialog-form-item > .el-form-item .el-input__inner:focus {
    border-color:#5171cb;
}
.dialog-form-item > .el-form-item .el-form-item__label {
    text-align: left;
}
.dialog-form-item > .el-select .el-input__inner {
    color: #333B48;
    height: 50px;
}
.dialog-form-item > .el-select-dropdown__item.selected {
    color: #000000;
}
.dialog-form-item > .el-select-dropdown__item {
    text-align: left;
}

.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #5171cb;
    border-color: #5171cb;
}

/*
 * button class
 */

 .el-button.enable-command-button {
     font-size: 14px;
     padding: 10px 30px;
     padding-left: 10px;
     padding-right: 16px;
     color: #ffffff;
     position: relative;
     display: inline-block;
     background-color: #5171cb;
     cursor: pointer;
 }
 .el-button.enable-command-button:hover,
 .el-button.enable-command-button:active,
 .el-button.enable-command-button:focus {
     color: #ffffff;
     background-color: #5171cb;
     border-color: #5171cb;
     opacity: 0.8;
 }

 .el-button.disable-command-button {
     font-size: 14px;
     padding: 10px 30px;
     padding-left: 10px;
     padding-right: 16px;
     color: #ffffff;
     position: relative;
     display: inline-block;
     background-color: #5171cb;
     cursor: not-allowed;
 }

 .el-button.disable-command-button {
     color: #ffffff;
     background-color: #5171cb;
     opacity: 0.3;
 }
 .el-button.disable-command-button:hover,
 .el-button.disable-command-button:active,
 .el-button.disable-command-button:focus {
     color: #ffffff;
     background-color: #5171cb;
     opacity: 0.3;
 }

.dialog-ok-button {
    display: inline-block;
}
.el-button.dialog-ok-button {
    font-size: 14px;
    height: 36px;
    min-width: 104px;
    padding: 0px 10px 0px 10px;
    color: #ffffff;
    background-color: #5171cb;
    display: inline-block;
    border-color: #5171cb;
}
.el-button.dialog-ok-button:hover,
.el-button.dialog-ok-button:active,
.el-button.dialog-ok-button:focus {
    color: #ffffff;
    background-color: #5171cb;
    border-color: #5171cb;
    opacity: 0.8;
}
.el-button.dialog-ok-button.is-disabled,
.el-button.dialog-ok-button.is-disabled:active,
.el-button.dialog-ok-button.is-disabled:focus,
.el-button.dialog-ok-button.is-disabled:hover {
    color: #ffffff;
    background-color: #5171cb;
    border-color: #5171cb;
    opacity: 0.3;
}

.dialog-small-button {
    display: inline-block;
}
.el-button.dialog-small-button {
    font-size: 12px;
    height: 30px;
    min-width: 104px;
    padding: 0px 10px 0px 10px;
    color: #ffffff;
    background-color: #5171cb;
    display: inline-block;
    border-color: #5171cb;
}
.el-button.dialog-small-button:hover,
.el-button.dialog-small-button:active,
.el-button.dialog-small-button:focus {
    color: #ffffff;
    background-color: #5171cb;
    border-color: #5171cb;
    opacity: 0.8;
}
.el-button.dialog-small-button.is-disabled,
.el-button.dialog-small-button.is-disabled:active,
.el-button.dialog-small-button.is-disabled:focus,
.el-button.dialog-small-button.is-disabled:hover {
    color: #ffffff;
    background-color: #5171cb;
    border-color: #5171cb;
    opacity: 0.3;
}

.dialog-cancel-button {
    display: inline-block;
}
.el-button.dialog-cancel-button {
    font-size: 14px;
    height: 36px;
    width: 104px;
    padding: 0;
    color: #000000;
    background-color: #fafafa;
}
.el-button.dialog-cancel-button:hover,
.el-button.dialog-cancel-button:active,
.el-button.dialog-cancel-button:focus {
    color: #333B48;
    background-color: #fafafa;
    border-color: #dcdfe6;
    opacity: 0.8;
    outline: none;
}
.el-button.default-button {
    color: #ffffff;
    background-color: #5171cb;
}
.el-button.default-button:hover,
.el-button.default-button:focus {
    color: #ffffff;
    background-color: #5171cb;
    opacity: 0.8;
}

.object-titlebox {
  width: 100%;
  background-color: #f6f6f6;
  display: table;
}
.object-titlebox img {
  display: inline;
  vertical-align: middle;
  height: 18px;
  padding-right: 4px;
}
.object-titlebox-left {
  padding: 10px;
  padding-left: 20px;
  color: #848991;
  font-size: 12px;
  vertical-align: middle;
  float: left;
}
.object-titlebox-right {
  padding: 10px;
  position: relative;
  text-align : right;
  vertical-align: middle;
  font-size: 12px;
}
.object-titlebox-text {
  padding-top: 10px;
  padding-bottom: 10px;
  color: #848991;
  font-size: 12px;
  vertical-align: middle;
}
.object-userlist-left {
  vertical-align: middle;
}
.object-userlist-right {
  text-align : right;
  float: right;
  vertical-align: middle;
 }
.object-userlist-right img {
  display: inline;
  vertical-align: middle;
  height: 18px;
  padding-right: 8px;
}
.object-item {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 14px;
}
.object-item2 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 0px;
    font-size: 14px;
    text-align: center;
}
.objectitem-record {
    border-bottom:1px #eee solid;
}
.objectitem-record-bottom {
    border-bottom:none;
}
.object-value {
    color: #848991;
}
.important-command-text {
    font-size: 12px;
    color: #d55169;
}
.important-command-text:hover {
    opacity: 0.7;
}
.normal-command-text {
    font-size: 12px;
    color: #5171cb;
}
.normal-command-text:hover {
    opacity: 0.7;
}

.bidirectional {
    height: 25px;
    vertical-align: middle;
}

.delete {
    height: 25px;
    vertical-align: middle;
}
.delete:active, .delete-tag:hover {
    opacity: 0.8;
}
.delete-innactive {
    height: 25px;
    vertical-align: middle;
}

.item-list-title {
    width: 100%;
    padding: 10px 0 10px 28px;
    display: table-row;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
    background-color: #f6f6f6;
}
.item-list-header {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 20px;
    font-size: 12px;
}

.userTagDisable {
  display: inline-block;
  border: 1px solid;
  border-radius: 30px;
  border-color: #5171cb;
  color: #5171cb;
  margin: 5px;
  padding: 6px;
  padding-left: 10px;
  opacity: 0.3;
}
.userTag {
  display: inline-block;
  border: 1px solid;
  border-radius: 30px;
  border-color: #5171cb;
  color: #5171cb;
  margin: 5px;
  padding: 6px;
  padding-left: 10px;
  white-space: nowrap;
  word-break: break-word;
  text-align: justify;
}
.userTag > .userTag-name {
  display: inline-block;
  vertical-align: middle;
  white-space: normal;
  max-width: 95%;
}
.userTagDisable > .closeTag,
.userTag > .closeTag {
  display: inline-block;
  cursor: pointer;
  border-radius: 4px;
  margin: 4px;
  vertical-align: middle;
}
.userTagDisable > .closeTag:active,
.userTag > .closeTag:active {
  background-color: gray;
}

.defaultTalkgroup {
    opacity: 0.3
}

.option-description {
    font-size: 12px;
    font-size: 12px;
    /* color: rgb(132, 137, 145); */
    background-color: #f6f6f6;
    color: #000;
    padding: 12px;
    border-radius: 4px;
    color: rgb(132, 137, 145);
}

.required {
    background-color: #d55169;
	border-radius: 2px;
	padding: 3px;
	color: #fff;
	font-size: 10px;
    -webkit-transform-origin: 0 0;
    -webkit-transform: scale(0.9);
    line-height: 11px;
	display:inline-block;
}

.license-record {
    width: 100%;
    border-bottom:1px #eee solid;
}
.license-record-no-hover-top {
    width: 100%;
    border-bottom: none;
}
.license-record-no-hover {
    width: 100%;
    border-bottom:1px #eee solid;
}
.license-record:hover
{
    background-color: #ecf1fa;
}

.license-record-bottom {
    width: 100%;
    border-bottom:none;
}
.license-record-bottom:hover
{
    background-color: #ecf1fa;
}
.license-record-no-hover-bottom {
    width: 100%;
    border-bottom:none;
}

.license-record-header {
    width: 100%;
    background-color: #f1f3f7;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
}
.license-item-title {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
}
.license-item-value {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 14px;
}
.license-item-header {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
}
.license-item-note {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
    color: #d55169;
}

.total-amount {
    font-size: 32px;
    color: #333b48;
}

.icon-help {
    padding-bottom: 3px;
    display: inline;
    vertical-align: middle;
    height: 15px;
}

.beside-line {
	color: #848991;
	font-size: 12px;
	display: flex;
	align-items: center;
}
.beside-line:before, .beside-line:after {
	content: "";
	flex-grow: 1;
	height: 1px;
	background: #eee;
	display: block;
}
.beside-line:before {
	margin-right: .4em;
}
.beside-line:after {
	margin-left: .4em;
}

.alertfield {
    margin-left: -10px;
    margin-top: -10px;
    width: calc(100% + 20px);
}
.alertrecord {
    background-color: #d55169;
    color: #ffffff;
    text-align: center;
    display: table-cell;
    height: 40px;
    padding-top: 10px;
}

.hint-table {
    margin: 0 50px;
}
.hint-table-title {
    padding: 5px 10px 0 10px;
    text-align: left;
    font-weight: 700;
}
.hint-table-item {
    padding:0 10px 10px 10px;
    text-align: left;
}

.notice-table {
    margin: 0 50px;
    border: solid 1px #eee;
}
.notice-table-title {
    padding: 20px 20px 0;
    text-align: left;
    font-weight: 700;
}
.notice-table-item {
    padding:5px 20px 20px 20px;
    text-align: left;
}

hr.hint-hr {
    border: none;
    height: 1px;
    background-color: #eee;
    margin: 0.3px 50px;
}

.error-message-text {
    color: #d55169;
    padding-left: 20px;
    font-size: 11px;
}

ul.el-dropdown-menu {
    background: #000;
    border: none;
    padding: 0;
    overflow: hidden;
}
li.el-dropdown-menu__item:focus, li.el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #5171cb;
    color: #fff;
}
li.el-dropdown-menu__item {
    color: #fff;
    font-size: 12px;
}
ul.el-popper[x-placement^=bottom] .popper__arrow:after {
    top: unset;
}
.manual-header-record {
    background-color: #f6f6f6
}
.manual-record-item {
    padding:10px;
}
.manual-frame {
    padding: 20px;
    color: #848991;
}
.manual-notes {
    background-color:#f6f6f6;
    padding:10px;
}
</style>

<style scoped>
.dropdown-link {
    background-color: transparent;
    border-color: transparent;
    color: #fff;
}

ul.navi.selected_menuitem {
    background-color: #5171cb;
}

.box {
    width: 100%;
    height: 64px;
    background-color: #0e1726;
    display: table;
    min-width: 830px;
}

.root {
    position: relative;
    top: 0px;
    left: 0px;
}

.aldiologo {
    height: 24px;
    padding-right: 10px;
}

.console-logo {
    height: 24px;
}
.console-logo-icon {
    float: left;
}
.console-logo-icon img {
    height: 24px;
    padding-right: 5px;
}
.console-logo-text {
    font-size: 12px;
    font-weight: 700;
    float: left;
    color: #fff;
    margin-top: 5px;
}

.navi-menu {
    width: 200px;
    height: 100%;
    background-color: #23282f;
}
.navi-menu-narrow {
    width: 64px;
    height: 100%;
    background-color: #23282f;
}

ul.navi {
  	margin: 0;
  	padding: 0;
}

ul.navi img {
    height: 25px;
}

a:link {
    color: #ffffff;
    text-decoration: none;
}
a:visited { color: #ffffff; }

.panel {
    position: absolute;
    top: 0px;
    left: 200px;
    right: 0px;
    bottom: 0px;
    overflow: hidden;
    background-color: white;
    min-width: 630px;
}
.panel-wide {
    position: absolute;
    top: 0px;
    left: 64px;
    min-width: 770px;
    right: 0px;
    bottom: 0px;
    overflow: hidden;
    background-color: white;
}
.dropdown-menu {
    padding-right:20px;
    display: inline-block;
}
.dropdown-menu >>> .el-button {
    background-color: transparent;
    border-color: transparent;
    color: #fff;
    cursor: initial;
    padding-right: 0;
    border: none;
}
.dropdown-menu >>> .el-dropdown__caret-button {
    padding-left: 10px;
    cursor: pointer;
}
.dropdown-menu >>> .el-dropdown__caret-button:before {
    background: none;
}
.dropdown-menu >>> .el-dropdown:before {
    background: none;
}

img.icon-lang {
    height: 20px;
    display: block;
    position: absolute;
    left: -12px;
    top: 1px;
}

.menu-change-button-field {
    display: block;
    text-align: right;
    padding-right: 20px;
}
.menu-change-icon {
    height: 25px;
    padding-left: 13px;
}
</style>
